import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ExTable,
    TableBody,
    TableHead,
    TableWrapper,
} from 'components/shared/widget'
import { useFetchCustomerOrdersApi, usePostCustomerOrderApi } from 'api/customer_order'
import { CustomerOrder, CustomerOrderForm, CustomerOrderSearchForm } from 'entities/customer_order'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { CustomerOrderColumnInfoList, CustomerOrderTableData } from './customer_order_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const CustomerOrdersPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<CustomerOrderSearchForm>()
    const searchForm = useForm<CustomerOrderSearchForm>(query)
    const api = useFetchCustomerOrdersApi(searchForm)
    const postForm = useForm<CustomerOrderForm>({})
    const postApi = usePostCustomerOrderApi()
    const customerOrderDisplaySetting = useDisplaySetting(CustomerOrderColumnInfoList(searchForm), 'customerOrder')
    const [showPostForm, setShowPostForm] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(postApi.loading)
        if (postApi.isSuccess()) {
            props.history.push('task_groups?kind=MATERIAL')
        }
    }, [postApi.loading])

    const handleClickRemoveFilter = (key: keyof CustomerOrderSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`customer_orders?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(postApi.loading)
        if (postApi.isSuccess()) {
            api.execute()
        }
    }, [postApi.loading])

    return (
        <>
            <ContentHeader
                headerTitle="customerOrder"
                left={
                    <>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={customerOrderDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={customerOrderDisplaySetting.getColumnLength()}>
                            {api.response.results.map((customerOrder: CustomerOrder) => {
                                return (
                                    <tr key={`customerOrder-${customerOrder.id}`}>
                                        <CustomerOrderTableData customerOrder={customerOrder} displaySetting={customerOrderDisplaySetting} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(CustomerOrdersPage)
